
//Typeahead wrapper functions
//allows the creation and binding of fields for selectize pluginName

//buildRoute(path,params)

//TODO turn this into a React component.

var typeaheads = {

	//all orgs
	orgLookup: function(selector){
		if(selector == undefined){
			console.error("typeaheads.orgLookup called without selector.")
			return false;
		}

		function getOrgLogoURL(image_url, academic){
			var has_logo = (image_url !== null && image_url.length > 0) ?  true : false;
			var academic = (academic !== null) ?  academic : false;
			if(has_logo){
				return image_url;
			}
			if(academic){
				return mantl.static_url + 'assets/images/icon-org-academic.svg';
			}
			//else
			return mantl.static_url + 'assets/images/icon-org-commercial.svg';
		}

		var typeahead = $(selector).selectize({
            preload: 'focus', //'focus',true,false
            valueField: 'id',
			plugins: ['remove_button','restore_on_backspace'],
            searchField: ['name', 'description'],
            maxItems: 1,
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
					var verified = (item.verified) ? '<span class="flag--verification"><img src="' + mantl.static_url + 'assets/images/icon-verified-org.svg" alt="Verified" title="Verified Organization" data-popover="tooltip" data-placement="top" /></span>' : '<span class="flag--verification"><img src="' + mantl.static_url + 'assets/images/icon-unverified-org.svg" alt="Verified" title="Unverified Organization" data-popover="tooltip" data-placement="top" /></span>';
                    return '<div><div class="organization-parent"><img class="avatar" alt="Logo for ' + item.name + '" src="' + getOrgLogoURL(item.image, item.academic) + '" />' + item.name + ' ' + verified + ' <span class="text--sm text--information float--right">' + item.website + '</span>' + '</div><p class="organization-role">' + item.description + '</p></div>';
                },
                item: function(item, escape) {
                    return '<span class="typeahead-selection"><img class="avatar" alt="Logo for ' + item.name + '" src="' + getOrgLogoURL(item.image, item.academic) + '" />' + item.name + '</span>';
                }
            },
            load: function(query, callback) {
				httpGet(buildRoute(mantlroutes.org_global_lookup + formatParams({
					pattern: query,
					num_results: 25 //number of options it will return on query
				}))).then(
	                function(value) {
	                    var response = JSON.parse(value);
                        callback(response);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading org list.', reason);
						alertify.error("Unable to load organizations list.")
	                });
            }
        });

		return typeahead;

	},

	//all org members
	orgMembers: function(selector,options){
		if(selector == undefined){
			console.error("typeaheads.orgMembers called without selector.")
			return false;
		}

		var defaults = {
			maxItems: 1,
			orgid: mantl.orgid,
			callback: false //do not confuse with load callback, which is native to plugin
	    }
	    var settings = $.extend( {}, defaults, options );

		var typeahead = $(selector).selectize({
            preload: 'focus', //'focus',true,false
            valueField: 'id',
			plugins: ['remove_button','restore_on_backspace'],
            searchField: ['first_name', 'last_name', 'username'],
            maxItems: settings.maxItems,
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    return '<div><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + ' <span class="flag flag--sm flag--muted">' + item.role + '</span></div>';
                },
                item: function(item, escape) {
					//on selection, we can use a callback to do something with the user selection, like populate some fields
					if(settings.callback){
						settings.callback(item);
					}
                    return '<span class="typeahead-selection"><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</span>';
                }
            },
            load: function(query, callback) {
				httpGet(buildRoute(mantlroutes.org_members,{ "orgid": settings.orgid }) + formatParams({
					pattern: query,
					num_results: 25 //number of options it will return on query
				})).then(
	                function(value) {
	                    var response = JSON.parse(value);
						var options = response.map(function(item) {
							var member = item.user;
							member.role = item.role;
							member.role_id = item.id;
	                    	return member;
						});
						callback(options);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading org members.', reason);
						alertify.error("Unable to load members list.")
	                });
            }
        });

		return typeahead;

	},

	//org staff are non learner org members. role=member filter will return "staff" roles
	orgStaff: function(selector){
		if(selector == undefined){
			console.error("typeaheads.orgStaff called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: 'focus', //'focus',true,false
            valueField: 'id',
			plugins: ['remove_button','restore_on_backspace'],
            searchField: ['first_name', 'last_name', 'username'],
            maxItems: 1,
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    return '<div><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</div>';
                },
                item: function(item, escape) {
                    return '<span class="typeahead-selection"><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</span>';
                }
            },
            load: function(query, callback) {
				httpGet(buildRoute(mantlroutes.org_members,{ "orgid": mantl.orgid }) + formatParams({
					role: "member",
					pattern: query,
					num_results: 25 //number of options it will return on query
				})).then(
	                function(value) {
	                    var response = JSON.parse(value);
	                    var options = response.map(function(item) {
	                    	return item.user;
						});
                        callback(options);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading org members.', reason);
						alertify.error("Unable to load members list.")
	                });
            }
        });

		return typeahead;

	},

	//org staff are non learner org members
	orgLearners: function(selector){
		if(selector == undefined){
			console.error("typeaheads.orgLearners called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: 'focus', //'focus',true,false
            valueField: 'id',
			plugins: ['remove_button','restore_on_backspace'],
            searchField: ['first_name', 'last_name', 'username'],
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    return '<div><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</div>';
                },
                item: function(item, escape) {
                    return '<span class="typeahead-selection"><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</span>';
                }
            },
            load: function(query, callback) {
				httpGet(buildRoute(mantlroutes.org_members,{ "orgid": mantl.orgid }) + formatParams({
					role: "learner",
					pattern: query,
					num_results: 25 //number of options it will return on query
				})).then(
	                function(value) {
	                    var response = JSON.parse(value);
	                    var options = response.map(function(item) {
	                    	return item.user;
						});
                        callback(options);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading org learners.', reason);
						alertify.error("Unable to load learners list.")
	                });
            }
        });

		return typeahead;
	},
	//singular case
	orgLearner: function(selector){
		if(selector == undefined){
			console.error("typeaheads.orgLearner called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: 'focus', //'focus',true,false
            valueField: 'id',
			plugins: ['remove_button','restore_on_backspace'],
            searchField: ['first_name', 'last_name', 'username'],
			maxItems: 1,
			options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    return '<div><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</div>';
                },
                item: function(item, escape) {
                    return '<span class="typeahead-selection"><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</span>';
                }
            },
            load: function(query, callback) {
				httpGet(buildRoute(mantlroutes.org_members,{ "orgid": mantl.orgid }) + formatParams({
					role: "learner",
					pattern: query,
					num_results: 25 //number of options it will return on query
				})).then(
	                function(value) {
	                    var response = JSON.parse(value);
	                    var options = response.map(function(item) {
	                    	return item.user;
						});
                        callback(options);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading org learners.', reason);
						alertify.error("Unable to load learners list.")
	                });
            }
        });
		return typeahead;
	},

	programLearners: function(selector){
		if(selector == undefined){
			console.error("typeaheads.programLearners called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: 'focus', //'focus',true,false
			plugins: ['restore_on_backspace'],
            valueField: 'id',
            searchField: ['full_name', 'username'],
            maxOptions: 10, //max suggestions
            maxItems: 1,
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    return '<div><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</div>';
                },
                item: function(item, escape) {
                    return '<span class="typeahead-selection"><img class="avatar" alt="' + item.full_name + '" src="' + item.avatar + '" />' + item.full_name + '</span>';
                }
            },
            load: function(query, callback) {
                this.settings.load = null; //erase this function so it only loads (prefectch) once and not with each query change
				httpGet(buildRoute(mantlroutes.program_learners,{ orgid: mantl.orgid, programid: mantl.programid })).then(
	                function(value) {
	                    var response = JSON.parse(value);
						var options = []; //translate response into one dimensional array of oject literals
			            response.forEach(function(element,index) {
			                var item = {};
			                item.first_name = element.role.user.first_name;
			                item.last_name = element.role.user.last_name;
							item.full_name = element.role.user.full_name;
			                item.username = element.role.user.username;
			                item.id = element.id;
							item.active = element.active;
			                options.push(item);
			            });

                        callback(options);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading program learners.', reason);
						alertify.error("Unable to load learners list.")
	                });
            }
        });

		return typeahead;

	},

	orgPrograms: function(selector){
		if(selector == undefined){
			console.error("typeaheads.orgPrograms called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: 'focus', //'focus',true,false
			plugins: ['remove_button','restore_on_backspace'],
            valueField: 'id',
            searchField: ['name'],
            maxOptions: 10, //max suggestions
            maxItems: 1,
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    return '<div>' + item.name + '</div>';
                },
                item: function(item, escape) {
                    return '<span class="typeahead-selection">' + item.name + '</span>';
                }
            },
            load: function(query, callback) {
                this.settings.load = null; //erase this function so it only loads (prefectch) once and not with each query change
				httpGet(buildRoute(mantlroutes.programs,{ orgid: mantl.orgid })).then(
	                function(value) {
	                    var response = JSON.parse(value);
						var options = response;
                        callback(options);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading org programs.', reason);
						alertify.error("Unable to load programs list.")
	                });
            }
        });

		return typeahead;

	},

	orgBadges: function(selector, options, initCallback){
		if(selector == undefined){
			console.error("typeaheads.orgBadges called without selector.")
			return false;
		}

		var defaults = {
			params: {}
	    }
	    var settings = $.extend( {}, defaults, options );

		var filter = formatParams(settings.params);;

		var typeahead = $(selector).selectize({
            preload: true, //'focus',true,false
			plugins: ['restore_on_backspace'],
            valueField: 'id',
            searchField: ['name','description'],
            maxOptions: 10, //max suggestions
            maxItems: 1,
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    if(item.image != null){
                        return '<div>' + '<img src="' + item.image + '" class="badge-disc" alt="Badge Artwork" /> ' + item.name + '</div>';
                    } else {
                        return '<div><span class="icon-disc"><i class="icon-image"><span class="screenreader">Image Icon</span></i></span> ' + item.name + '</div>';
                    }

                },
                item: function(item, escape) {
                    if(item.image != null){
                        return '<span class="typeahead-selection">' + '<img src="' + item.image + '" class="avatar" alt="Badge Artwork" /> ' + item.name + '</span>';
                    } else {
                        return '<span class="typeahead-selection"><i class="icon-image"><span class="screenreader">Image Icon</span></i> ' + item.name + '</span>';
                    }

                }
            },
            load: function(query, callback) {
                this.settings.load = null; //erase this function so it only loads (prefectch) once and not with each query change
				httpGet(buildRoute(mantlroutes.org_badges,{ orgid: mantl.orgid, programid: mantl.programid }) + filter).then(
	                function(value) {
	                    var response = JSON.parse(value);
						var options = response;
                        callback(options);
						if(initCallback){
							initCallback();
						}
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading org badges.', reason);
						alertify.error("Unable to load badges list.")
	                });
            }
        });

		return typeahead;

	},

	programBadges: function(selector){
		if(selector == undefined){
			console.error("typeaheads.programBadges called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: 'focus', //'focus',true,false
			plugins: ['restore_on_backspace'],
            valueField: 'id',
            searchField: ['name','description'],
            maxOptions: 10, //max suggestions
            maxItems: 1,
            options: [],
            create: false,
            render: {
                option: function(item, escape) {
                    return '<div>' + item.name + '</div>';
                },
                item: function(item, escape) {
                    return '<span class="typeahead-selection">' + item.name + '</span>';
                }
            },
            load: function(query, callback) {
                this.settings.load = null; //erase this function so it only loads (prefectch) once and not with each query change
				httpGet(buildRoute(mantlroutes.program_items,{ orgid: mantl.orgid, programid: mantl.programid })).then(
	                function(value) {
	                    var response = JSON.parse(value);
						var options = [];
						//transform program chains into flat list of badges
						response.forEach(function(stage){
							stage.chains.forEach(function(chain){
								chain.nodes.forEach(function(node){
									options.push(node.item);
								});
							});
						});

                        callback(options);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading program badges typeahead.', reason);
						alertify.error("Unable to load badges list.")
	                });
            }
        });

		return typeahead;

	},

	skillTags: function(selector,seed){
		if(selector == undefined){
			console.error("typeaheads.skillTags called without selector.")
			return false;
		}
		var seedList = seed || [];
		var typeahead = $(selector).selectize({
            preload: true, //'focus',true,false
			plugins: ['remove_button','restore_on_backspace','selectize-plugin-a11y'],
			valueField: 'tag',
			searchField: ['tag'],
			labelField: 'tag',
			delimiter: ',',
            persist: false,
            create: true,
			render: {
                option: function(item, escape) {
					var optid = item.tag.replace(' ', '');
					var flag = (item.goal) ? ' <span class="flag flag--faint flag--small">Goal</span>' : '';
					return `<div role="option" id="${optid}">${item.tag}${flag}</div>`;
                }
            },
            load: function(query, callback) {
                //this.settings.load = null;
				if(query.lenth == 0 && seedList.length > 1){
					callback(seedList);
				} else {
					httpGet( buildRoute(mantlroutes.skill_list) + formatParams({
						pattern: query,
						num_results: 20 //number of options it will return on query
					})).then(
		                function(value) {
		                    var response = JSON.parse(value);
							response = response.concat(seedList);
	                        callback(response);
		                })
		            .catch(
		                function(reason) {
		                    console.error('Error loading skill tags.', reason);
		                });
				}

            }
        });

		return typeahead;
	},

	skillTagsList: function(selector){
		if(selector == undefined){
			console.error("typeaheads.skillTagsList called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: false, //'focus',true,false
			plugins: ['remove_button','restore_on_backspace'],
			valueField: 'tag',
			searchField: ['tag'],
			labelField: 'tag',
			delimiter: ',',
            persist: false,
            create: false,
			render: {
				option: function($item, escape) {
					return `<div class="option" role="option" id="${$item.tag.replace(' ', '')}">${$item.tag}</div>`
				}
			},
            load: function(query, callback) {
                //this.settings.load = null;
				httpGet( buildRoute(mantlroutes.skill_list) + formatParams({
					pattern: query,
					num_results: 25 //number of options it will return on query
				})).then(
	                function(value) {
	                    var response = JSON.parse(value);
                        callback(response);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading skill tags.', reason);
	                });
            }
        });

		return typeahead;

	},
	// Careers is deprecated
	occupation: function(selector){
		if(selector == undefined){
			console.error("typeaheads.occupations called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: false, //'focus',true,false
			plugins: ['restore_on_backspace'],
			valueField: 'id',
			searchField: ['title'],
			labelField: 'title',
			maxItems: 1,
			maxOptions: 10, //max suggestions
			delimiter: ',',
            persist: false,
			create: false,
			render: {
                item: function(item, escape) {
                    return '<span class="typeahead-selection" aria-selected="true">' + item.title + '</span>';
                },
				option: function($item, escape) {
					return `<div class="option" role="option" id="${$item.title.replace(' ', '')}">${$item.title}</div>`
				}
			},
            load: function(query, callback) {
                //this.settings.load = null;
				httpGet( buildRoute(mantlroutes.occupation_list) + formatParams({
					pattern: query,
					page_size: 20 //number of options it will return on query
				})).then(
	                function(value) {
						var response = JSON.parse(value);
						// console.log(response)
                        callback(response.results);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading careers.', JSON.parse(reason));
	                });
            }
        });

		return typeahead;

	},
	// Careers is deprecated. Leaving for temp reference. TODO: delete
	careers: function(selector){
		if(selector == undefined){
			console.error("typeaheads.carrers called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: false, //'focus',true,false
			plugins: ['restore_on_backspace'],
			valueField: 'id',
			searchField: ['title'],
			labelField: 'title',
			maxOptions: 10, //max suggestions
			delimiter: ',',
            persist: false,
            create: false,
            load: function(query, callback) {
                //this.settings.load = null;
				httpGet( buildRoute(mantlroutes.career_list) + formatParams({
					pattern: query,
					num_results: 50 //number of options it will return on query
				})).then(
	                function(value) {
	                    var response = JSON.parse(value);
                        callback(response);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading careers.', JSON.parse(reason));
	                });
            }
        });

		return typeahead;

	},
	// Careers is deprecated. Leaving for temp reference. TODO: delete
	//single career lookup
	career: function(selector){
		if(selector == undefined){
			console.error("typeaheads.carrers called without selector.")
			return false;
		}
		var typeahead = $(selector).selectize({
            preload: false, //'focus',true,false
			plugins: ['restore_on_backspace'],
			valueField: 'id',
			searchField: ['title'],
			labelField: 'title',
			maxItems: 1,
			maxOptions: 10, //max suggestions
			delimiter: ',',
            persist: false,
            create: false,
			render: {
                item: function(item, escape) {
                    return '<span class="typeahead-selection">' + item.title + '</span>';
                }
            },
            load: function(query, callback) {
                //this.settings.load = null;
				httpGet( buildRoute(mantlroutes.career_list) + formatParams({
					pattern: query,
					num_results: 50 //number of options it will return on query
				})).then(
	                function(value) {
	                    var response = JSON.parse(value);
                        callback(response);
	                })
	            .catch(
	                function(reason) {
	                    console.error('Error loading careers.', JSON.parse(reason));
	                });
            }
        });

		return typeahead;

	}

}
